export enum CategoryName {
  Registration = 'registration',
  MobileID = 'registration',
  Common = 'common',
  Refinancing = 'refinancing',
}
